import { Container } from "pixi.js";
import { Manager } from "../core/Manager";
//import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { FreeGameScene } from "./FreeGameScene";

import { sound, Sound } from "@pixi/sound";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusicVolume, isMusicBtnOnGlobal, RespinIndex, setBackgorundMusic, setbaseGameLastReeelSymbols, setIsGameAlreadyLoaded, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { CasinoChannelHandler, casinoEventEmitter } from "../core/CasinoChannelHandler";
import { BigWin } from "./BigWin";
// import { REEL_DIVIDER, REEL_FRAME, REEL_NUMBERS, REEL_WIDTH } from "../config/reelConfig";
// import { getSpineSymbol } from "../config/getSymbol";




import { isGameAlreadyLoaded } from "../config/GlobalVariableConfig";
import { MaxGameWidthHeight } from "../config/reelConfig";
//import { DisplayComponent } from "../core/displays/DisplayComponent";
import { CharacterComponent } from "../components/character/CharacterComponent";
import { FeaturePot } from "../components/featurePot/FeaturePot";
import { FeaturePotComponent } from "../components/featurePot/FeaturePotComponent";
import { GameIntroComponent } from "../components/gameIntro/GameIntroComponent";
import { LogoComponent } from "../components/logo/LogoComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { Trails } from "../components/trail/Trails";
import { TrailsComponent } from "../components/trail/TrailsComponent";
import { TransCoinsComponent } from "../components/TransCoins/TransCoinsComponent";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { EventConstants } from "../gameClientEvents/EventConstants";
import { GameEvents } from "../gameClientEvents/GameEvents";
import { SoundConstants } from "../gameClientEvents/SoundConstants";
import { spinData } from "../server/getServerResposesFun";
import type { FeatureIndicatorColor } from "./Banner";
import { BaseScene } from "./BaseScene";

declare const window: any;
// const translationManager = window.hacksawCasino.Translation;

// let hand: Spine;

// let tweenLogo: Tween<Spine>;
const tweenGroup: Group = new Group();
export class BaseGameScene extends BaseScene {

    // Asset bundles
    override assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];

    // Containers
    //private background = new Container();
    //private reelFrame = new Container();

    //private gameIntro: Spine | null = null;

    //private reels: Reels | null = null;
    // private banner: Banner | null = null;
    //private bigWin: BigWin | null = null;
    private readonly onRoundStarted = this.handleRoundStarted.bind(this);
    private readonly onBetLevelUpdated = this.handleBetLevelUpdated.bind(this);
    private readonly onBetChanged = this.handleBetChanged.bind(this);

    private backgroundMusic: Sound | null = null;

    private freSpinTrigger: number = 0;
    private freSpinTriggerBaseWin: number = 0;

    private freeGameScene: FreeGameScene | null = null;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;

    //private triggeringFeatureContainer = new Container();

    private jackpotPanelContainer = new Container();


    //private boundShakeEffect: () => void;
    //private boundTriggeringFeatureCollectEffect: () => void;

    private pointerDownHandlerBase: () => void;

    private lineToggleTimeout: ReturnType<typeof setTimeout>;
    private togglePlay: boolean = false;
    public trails: Trails | null = null;
    private featurePots: FeaturePot | null = null;

    // private characterContainer = new Container();

    constructor() {
        super();

        this.setupEventListeners();

        //this.boundShakeEffect = this.shakeEffect.bind(this);
        //this.boundTriggeringFeatureCollectEffect = this.triggeringFeatureCollectEffect.bind(this);

        this.pointerDownHandlerBase = this.onPointerDown.bind(this);

        //reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        //reelSpinEmitter.off('potCollect', this.boundTriggeringFeatureCollectEffect);

        //reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);
        //reelSpinEmitter.on('potCollect', this.boundTriggeringFeatureCollectEffect);

    }

    private setupEventListeners(): void {
        // casinoEventEmitter.on('roundEnded', this.handleRoundEnded.bind(this));
        casinoEventEmitter.on('roundStarted', this.onRoundStarted);

        // Listen for bet level updates to refresh jackpot values
        casinoEventEmitter.on('updateBetLevel', this.onBetLevelUpdated);
        GameEvents.emitter.on(EventConstants.GAME_INTRO_COMPLETE, this.onIntroComplete, this);
        casinoEventEmitter.on('betChanged', this.onBetChanged);
    }

    override  destroy() {
        DisplayComponent.unregister(GameIntroComponent);
        // Unbind the event listener

        casinoEventEmitter.off('updateBetLevel', this.onBetLevelUpdated);
        casinoEventEmitter.off('roundStarted', this.onRoundStarted);
        casinoEventEmitter.off('betChanged', this.onBetChanged);
        GameEvents.emitter.off(EventConstants.GAME_INTRO_COMPLETE, this.onIntroComplete, this);
        console.log("inside override  destroy")

        //reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        //reelSpinEmitter.off('potcollect', this.boundTriggeringFeatureCollectEffect);

        casinoEventEmitter.removeAllListeners('roundStarted');
        DisplayComponent.unregister(ReelComponent);
        DisplayComponent.unregister(TransCoinsComponent);
        DisplayComponent.unregister(TrailsComponent);
        DisplayComponent.unregister(FeaturePotComponent);

        // this.stopIdleCheck();
        this.reels?.destroy();
        this.reels = null;
        super.destroy({ children: true, texture: false });
    }

    // private handleRoundEnded(data: any): void {
    //     console.log('GameScene - roundEnded:', data);
    //     // Add logic to handle round end if needed
    // }

    private handleBetLevelUpdated(data: any): void {
        console.log('GameScene - betLevelUpdated:', data);
        // Update jackpot values when bet level changes
        // this.updateJackpotValues(data.betAmount);
    }


    // private shakeEffect() {

    //     console.log("inside shakeEffect");

    //     let duration = 250;
    //     let intensity = 20;

    //     const original = { x: this.x, y: this.y };
    //     const offset = { x: 0, y: 0 };

    //     const tween = new Tween(offset, tweenGroup)
    //         .to({ x: 0, y: 0 }, duration)
    //         .onUpdate(() => {
    //             this.x = original.x + (Math.random() - 0.5) * intensity;
    //             this.y = original.y + (Math.random() - 0.5) * intensity;
    //         })
    //         .onComplete(() => {
    //             this.x = original.x;
    //             this.y = original.y;
    //             tweenGroup.remove(tween);
    //         })
    //         .start();
    // }



    private async handleRoundStarted() {
        // console.log('GameScene - betAccepted:', spinResponseData);
        // setSpinResponseDataGlobal(spinResponseData);
        sound.play(SoundConstants.BUTTON_CLICK, { volume: 1 });
        this.spinReel();

        // // Delay result display report
        // setTimeout(() => {

        // }, 500);

        // if (!spinData.dataFeatched) {
        //     await this.waitForData();
        // }



    }

    private handleBetChanged() {
        console.log('GameScene - betChanged:');
        this.resetToggleTimeout();
        this.reels?.resetWinsOnBetChange();
    }

    // private waitForData(): Promise<void> {
    //     return new Promise<void>((resolve) => {
    //         const checkInterval = setInterval(() => {
    //             if (spinData.dataFeatched) {
    //                 clearInterval(checkInterval);
    //                 resolve();
    //             }
    //         }, 100); // Check every 100ms

    //     });
    // }

    private onPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage pointerdown");
        this.freeGameSceneChnage();

        Manager.banner.off('pointerdown', this.pointerDownHandlerBase);
    }

    private onIntroComplete() {
        this.reelFrame.alpha = 1;
        this.setupBGSound();
        CasinoChannelHandler.reportGameStarted();
        setIsGameAlreadyLoaded(true);
    }

    public async constructorWithAssets(): Promise<void> {



        //this.setupBackground();
        this.initBaseLayering();
        //this.addChild(this.background);
        //this.setupLogo();

        // this.setupBGSound();

        //this.reels = new Reels();
        // this.reels.label = "AllReels";
        // this.background.addChild(this.reels);
        this.addReelComponent();
        this.addTransCoinsComponent();
        //this.reels.position.set(1090, 1048);
        //this.reels.alpha = 0;
        //this.setupFeatureIndicators();

        if (isGameAlreadyLoaded) { // meaning coming from free game;

            this.setupReelFrame("reelBackSkel", "reelBackAtlas", false);
            // when coming from free-> base then music will be chnaged in the banner disappear

            // this.setupBGSound();

        }
        else {
            // this.setupReelFrame("reelBackSkel", "reelBackAtlas", true);
            // the following will skip the intro in the game
            this.addComponent(GameIntroComponent, this);
            this.setupReelFrame("reelBackSkel", "reelBackAtlas", false);
            this.setupBGSound();
        }
        //this.setupFeatureIndicators();
        this.addFeaturePotComponent();
        this.addTrailComponent();
        this.setupCommonUI();
        // this.addComponent(GameIntroComponent, this);
        // this.setupJackpotPanel();


        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);
        this.addChild(this.bigWin);



        // setTimeout(async () => {
        //     await this.bigWin.bigWinFunction(10000);
        // }, 2000);



        // this.banner = new Banner(Manager.screenwidth, Manager.screenHeight);
        // this.addChild(Manager.banner);

        // Manager.banner.bgContainer.once('pointerdown', () => {
        //     clearTimeout(this.autoTriggerTimeout);
        //     console.log("calling freeGameSceneChnage pointerdown")
        //     this.freeGameSceneChnage();
        // });


        // const idRandom = 7;
        // const symbol1 = getSpineSymbol(idRandom);
        // symbol1.state.setAnimation(0, "flip", true);
        // symbol1.position.set(-200, 200);
        // this.reels.addChild(symbol1);

        // const symbol2 = getSpineSymbol(idRandom);
        // symbol2.state.setAnimation(0, "static", true);
        // symbol2.position.set(300, 200);
        // this.reels.addChild(symbol2);



        // setTimeout(() => {
        //     symbol.state.clearTrack(0);
        //     symbol.skeleton.setToSetupPose();
        // }, 2000);

        // await Manager.banner.appearFreeGameIntroBanner(3, ['blue', 'green', 'red']); // zeus, poseidon, hades
        // await Manager.banner.appearFreeGameOutroBanner(22513.65, 10);

        // await this.bigWin.bigWinFunction(1000);

        // await this.banner.appearFreeGameIntroBanner(10);

        //***********  translation ******************/
        //"free_spins_splash_body": "The best things in life are free!"
        // const string1 = translationManager.game('free_spins_splash_body');
        // console.log(string1);

        // // "num_free_spins_played": ":totalFreespins free spins played :x",
        // const string2 = translationManager.game('num_free_spins_played', null, { 'totalFreespins': 10, 'x': 20 });
        // console.log(string2);


        // const textval = new BitmapText({
        //     text: "123456789.0,",
        //     style: {
        //         fontFamily: 'Street_knockout_win2',
        //         fontSize: 60
        //     }
        // });
        // textval.position.set(-200, -200);
        // this.reels.addChild(textval);


        this.resize(Manager.screenwidth, Manager.screenHeight);

    }

    private addReelComponent(): void {
        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();
        this.reels.label = "AllReels";
        this.background.addChild(this.reels);
    }

    private addTransCoinsComponent(): void {
        DisplayComponent.register(new DisplayComponentFactory(TransCoinsComponent));
        const transCoins = DisplayComponent.get(TransCoinsComponent);
        transCoins.init();
    }


    private setupBGSound() {
        this.backgroundMusic = sound.find('base_music_loop'); // initialize with ambient sound
        setBackgorundMusic(this.backgroundMusic);

        if (this.backgroundMusic) {
            this.backgroundMusic.loop = true;
            this.backgroundMusic.volume = 0;//currentBackgorundMusicVolume;
            // console.log("this.backgroundMusic.volume", this.backgroundMusic.volume);
            this.backgroundMusic.singleInstance = true;
            // this.backgroundMusic.speed = 0.5;
            this.backgroundMusic.play();

            this.backgroundMusic.muted = !isMusicBtnOnGlobal;

            const tween = new Tween(this.backgroundMusic, tweenGroup)
                .to({ volume: currentBackgorundMusicVolume }, 2000)
                .onComplete(() => {
                    tweenGroup.remove(tween);
                })
                .start();

        }
    }

    private callFreeGameSceneChnageAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            console.log("calling freeGameSceneChnage auto")
            clearTimeout(this.autoTriggerTimeout);
            this.freeGameSceneChnage();
        }, 10000); // 10 seconds
    }

    private resetToggleTimeout() {
        clearTimeout(this.lineToggleTimeout);
        this.lineToggleTimeout = undefined;
        this.togglePlay = false;
    }

    private async spinReel(): Promise<void> {

        this.resetToggleTimeout();

        if (this.reels) {

            const [freeGameTrigger, winAmount] = await this.reels.startPlay("BASE");
            console.log("in GameScene freeGameTrigger winAmount RespinIndex.value", freeGameTrigger, winAmount, RespinIndex.value);


            if (this.reels.isBetDecline) {
                console.log("in Gamescene- Bet declined");
                this.reels?.setReelRunning(false);
                return;
            }

            // const transformCoins = spinData?.respins?.[0]?.transformCoins;
            // if (transformCoins && transformCoins.length > 0) {
            //     await this.callTranformCoins(transformCoins);
            // }
            if (freeGameTrigger > 0 && Manager.banner) {

                const indicatorColors: FeatureIndicatorColor[] = (spinData.triggerFeatures ?? [])
                    .map((feature) => {
                        switch (feature) {
                            case "poseidon":
                                return "green";
                            case "zeus":
                                return "blue";
                            case "hades":
                                return "red";
                            default:
                                return undefined;
                        }
                    })
                    .filter((v): v is FeatureIndicatorColor => Boolean(v));

                //await this.playTriggeringFeatureAnimation(potType);

                // await new Promise((resolve) => setTimeout(resolve, 2000000));
                setbaseGameLastReeelSymbols(spinData.respins[RespinIndex.value - 2].reelSymbols);
                this.freSpinTrigger = freeGameTrigger;
                this.freSpinTriggerBaseWin = winAmount;

                // await this.freeGameSceneChnage(freeGameTrigger, winAmount);
                // this.backgroundMusic?.stop();

                // const randomIndex = Math.floor(Math.random() * 2); // 0, 1, or 2
                // const winVariant = randomIndex == 0 ? `win_2` : `win_3`;
                // reelSpinEmitter.emit('animateCharacter', winVariant);
                // this.animateCharacter(winVariant);


                Manager.casinoChannelHandler.reportFeatureEnter();


                await Manager.banner.appearFreeGameIntroBanner(this.freSpinTrigger, indicatorColors);
                //attach a listner now
                // Manager.banner.on('pointerdown', this.pointerDownHandlerBase);

                console.log("appearFreeGameIntroBanner");

                if (willBannerAutoProceedGlobal) {
                    this.callFreeGameSceneChnageAuto();
                }

                this.freeGameScene = new FreeGameScene(this.freSpinTrigger, this.freSpinTriggerBaseWin);
                await Manager.changeScene(this.freeGameScene, false);

                // this.freeGameSceneChnage(this.freSpinTrigger, this.freSpinTriggerBaseWin)

                //attach a listner now
                Manager.banner.on('pointerdown', this.pointerDownHandlerBase);
            }
            else {
                await this.bigWin?.bigWinFunction(winAmount);
                Manager.casinoChannelHandler.reportGameRoundCompleted();
                // reportGameRoundCompleted();
            }

            this.togglePlay = true;

            if (freeGameTrigger === -2) { // max win reached
                Manager.casinoChannelHandler.reportMaxWin();
            }

            // this.reels?.setReelRunning(false);

            if (this.togglePlay && winAmount > 0) {
                this.lineToggleTimeout = setTimeout(() => {
                    this.reels?.lineToggle(0); // for toggle respin index will always be 0
                }, 2000);
            }

            // console.log("gggg")
        }
    }

    // private callTranformCoins(transformCoins: ITransCoin[]): Promise<void> {
    //     return new Promise<void>(async (resolve) => {
    //         await DisplayComponent.get(TransCoinsComponent).startTransformFeature(transformCoins, resolve);
    //     });
    // }

    private async freeGameSceneChnage() {
        if (this.autoTriggerTimeout) {
            clearTimeout(this.autoTriggerTimeout);
            this.autoTriggerTimeout = undefined;
        }
        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner();
        DisplayComponent.get(CharacterComponent).configureForTriggeredFeatures(spinData.triggerFeatures ?? []);
        this.freeGameScene?.freeSpinPlay();
        // Manager.casinoChannelHandler.reportFeatureEnter();
        // const game = new FreeGameScene(freeGameTrigger, baseGameWin);
        // await Manager.changeScene(game, false);
    }


    // private setupIntro(): void {
    //     this.gameIntro = Spine.from({
    //         skeleton: "gameIntroSkel",
    //         atlas: "gameIntroAtlas"
    //     })
    //     this.gameIntro.position.set(MaxGameWidthHeight / 2, MaxGameWidthHeight / 2);
    //     this.gameIntro.label = "gameIntro";
    //     this.addChild(this.gameIntro);
    // }

    // private async setupReelFrame(doAnimate: boolean): Promise<void> {
    //     doAnimate;
    //     const reelBack = Spine.from({
    //         skeleton: "reelBackSkel",
    //         atlas: "reelBackAtlas",
    //     });

    //     reelBack.state.setAnimation(0, "reel", true);
    //     reelBack.position.set(5, 170);
    //     this.reelFrame.addChild(reelBack);

    //     this.reels.position.set(-493, -165);
    //     this.reelFrame.addChild(this.reels);
    //     this.background.addChild(this.reelFrame);

    //     this.reelFrame.alpha = 1;

    //     // this.setupIntro();

    //     // doAnimate = false;

    //     // if (doAnimate) {

    //     //     //put reel logo mult on top

    //     //     this.gameIntro.state.addListener({
    //     //         start: () => {

    //     //             // sound.play('Intro_transition', { volume: 1 });
    //     //             setTimeout(() => {
    //     //                 sound.play("Intro_transition", { volume: 1 });
    //     //             }, 750);

    //     //             const bgAlphaTime = setTimeout(() => {
    //     //                 this.reelFrame.alpha = 1;
    //     //                 clearTimeout(bgAlphaTime);
    //     //             }, 3000);

    //     //         },
    //     //         event: (_entry, event) => {
    //     //             if (event.data.name === "change") {
    //     //                 this.setupBGSound();
    //     //                 CasinoChannelHandler.reportGameStarted();
    //     //                 setIsGameAlreadyLoaded(true);
    //     //             }
    //     //         },
    //     //         complete: () => {
    //     //             this.gameIntro.state.clearListeners();

    //     //             this.removeChild(this.gameIntro);
    //     //             this.gameIntro.destroy();
    //     //             this.gameIntro = null;
    //     //         }
    //     //     });

    //     //     this.gameIntro.state.setAnimation(0, "game_intro", false);

    //     // }
    //     // else {

    //     //     this.removeChild(this.gameIntro);
    //     //     this.gameIntro.destroy();
    //     //     this.gameIntro = null;

    //     //     this.reelFrame.alpha = 1;
    //     // }

    // }

    // //green pot
    // private greenFeatureIndicator: Spine;
    // //blue pot
    // private blueFeatureIndicator: Spine;
    // //pink pot
    // private redFeatureIndicator: Spine;

    // Feature pots setup
    // private setupFeatureIndicators(): void {

    //     this.greenFeatureIndicator = Spine.from({
    //         skeleton: "oceanTriggerIndicatorSkel",
    //         atlas: "oceanTriggerIndicatorAtlas",
    //     });

    //     //blue pot
    //     this.blueFeatureIndicator = Spine.from({
    //         skeleton: "lightTriggerIndicatorSkel",
    //         atlas: "lightTriggerIndicatorAtlas",
    //     });

    //     //pink pot
    //     this.redFeatureIndicator = Spine.from({
    //         skeleton: "infernoTriggerIndicatorSkel",
    //         atlas: "infernoTriggerIndicatorAtlas",
    //     });

    //     this.triggeringFeatureContainer.position.set(8, -207);
    //     this.triggeringFeatureContainer.label = "Triggering Feature Container";



    //     this.greenFeatureIndicator.state.setAnimation(0, "loop", true);
    //     this.greenFeatureIndicator.position.set(250, -140);
    //     this.greenFeatureIndicator.label = "Green Pot";
    //     this.triggeringFeatureContainer.addChild(this.greenFeatureIndicator);



    //     this.blueFeatureIndicator.state.setAnimation(0, "loop", true);
    //     this.blueFeatureIndicator.position.set(-250, -140);
    //     this.blueFeatureIndicator.label = "Blue Pot";
    //     this.triggeringFeatureContainer.addChild(this.blueFeatureIndicator);



    //     this.redFeatureIndicator.state.setAnimation(0, "loop", true);
    //     this.redFeatureIndicator.position.set(0, -140);
    //     this.redFeatureIndicator.label = "Pink Pot";
    //     this.triggeringFeatureContainer.addChild(this.redFeatureIndicator);

    //     this.reelFrame.addChild(this.triggeringFeatureContainer);

    //     // this.collectPot(1);


    //     this.greenFeatureIndicator.state.addListener({
    //         complete: (entry: any) => {
    //             if (["collect", "trigger"].includes(entry.animation.name)) {
    //                 this.greenFeatureIndicator.state.setAnimation(0, "loop", true);
    //             }
    //         }
    //     });

    //     this.blueFeatureIndicator.state.addListener({
    //         complete: (entry: any) => {
    //             if (["collect", "trigger"].includes(entry.animation.name)) {
    //                 this.blueFeatureIndicator.state.setAnimation(0, "loop", true);
    //             }
    //         }
    //     });

    //     this.redFeatureIndicator.state.addListener({
    //         complete: (entry: any) => {
    //             if (["collect", "trigger"].includes(entry.animation.name)) {
    //                 this.redFeatureIndicator.state.setAnimation(0, "loop", true);
    //             }
    //         }
    //     });

    // }

    // private triggeringFeatureCollectEffect(potNum: number) {

    //     console.log("inside triggeringFeatureCollectEffect", potNum);

    //     if (potNum == 1) { // greenFeatureIndicator
    //         this.greenFeatureIndicator.state.setAnimation(0, "collect", false);
    //     }
    //     else if (potNum == 2) { // blueFeatureIndicator
    //         this.blueFeatureIndicator.state.setAnimation(0, "collect", false);
    //     }
    //     else if (potNum == 3) { // redFeatureIndicator
    //         this.redFeatureIndicator.state.setAnimation(0, "collect", false);
    //     }

    // }

    // private async playTriggeringFeatureAnimation(potTypes: PotType[]): Promise<void> {
    //     // Array of promises for each triggered pot animation
    //     const animationPromises: Promise<void>[] = [];

    //     for (const type of potTypes) {
    //         let triggeringIndicators: Spine | null = null;

    //         // Identify which pot spine to use based on type
    //         // 'extraSpin', 'doubleReels', 'multipliers'
    //         switch (type) {
    //             case "doubleReels":
    //                 triggeringIndicators = this.greenFeatureIndicator;
    //                 break;
    //             case "extraSpin":
    //                 triggeringIndicators = this.blueFeatureIndicator;
    //                 break;
    //             case "multipliers":
    //                 triggeringIndicators = this.redFeatureIndicator;
    //                 break;
    //         }

    //         const promise = new Promise<void>((resolve) => {
    //             // Set the animation and resolve once complete
    //             let featureTriggeringListner = {
    //                 complete: () => {
    //                     triggeringIndicators.state.removeListener(featureTriggeringListner);
    //                     resolve();
    //                 }
    //             };
    //             if (triggeringIndicators?.state) {
    //                 triggeringIndicators.state.addListener(featureTriggeringListner);
    //                 triggeringIndicators.state.setAnimation(0, "triger", false);
    //             } else {
    //                 resolve(); // If for some reason the spine is not found, resolve immediately to avoid blocking
    //             }

    //         });
    //         animationPromises.push(promise);
    //     }

    //     // Wait until all triggered animations complete
    //     await Promise.all(animationPromises);
    // }

    private addTrailComponent(): void {
        DisplayComponent.register(new DisplayComponentFactory(TrailsComponent));
        DisplayComponent.get(TrailsComponent).init();
        this.trails = DisplayComponent.get(TrailsComponent).getInstance();
        this.trails.label = "Trails";
        this.reelFrame.addChild(this.trails);
    }

    private addFeaturePotComponent(): void {
        DisplayComponent.register(new DisplayComponentFactory(FeaturePotComponent));
        DisplayComponent.get(FeaturePotComponent).init();
        this.featurePots = DisplayComponent.get(FeaturePotComponent).getInstance();
        this.featurePots.label = "FeaturePots";
        this.reelFrame.addChild(this.featurePots);
    }




    public override update(): void {
        tweenGroup?.update();
        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public override resize(screenWidth: number, screenHeight: number): void {

        // this.screenWidth = screenWidth;
        // this.screenHeight = screenHeight;
        super.resize(screenWidth, screenHeight);
        let scale: number;

        //let bgScale;
        //const BG_SCALE_FACTOR = Math.max(screenWidth / MaxGameWidthHeight, screenHeight / MaxGameWidthHeight);
        const character = DisplayComponent.get(CharacterComponent).getInstance();

        if (screenWidth > screenHeight) {
            scale = 1 * Math.min(screenWidth / 1920, screenHeight / 1080);
            //bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale.set(scale, scale);

            const xPos = (MaxGameWidthHeight * scale - screenWidth) / 2;
            const yPos = ((MaxGameWidthHeight + 0) * scale - screenHeight) / 2;

            // this.y = -200 * scale;

            this.background.x = -xPos;
            this.background.y = -yPos;

            // this.addChild(this.background);
            // this.addChild(this.game);

            this.reelFrame.scale = 0.9;
            this.reelFrame.position.set(1024, 900);

            this.jackpotPanelContainer.scale.set(0.8)
            this.jackpotPanelContainer.position.set(620, 1235);

            this.background.addChild(this.reelFrame);
            this.background.addChild(this.jackpotPanelContainer);
            // if (this.gameIntro) {

            //     this.addChild(this.gameIntro);
            //     this.gameIntro.scale.set(bgScale, bgScale)
            //     const bgXPos = screenWidth / 2;
            //     const bgYPos = screenHeight / 2;
            //     this.gameIntro.position.set(bgXPos, bgYPos);
            // }
            DisplayComponent.get(LogoComponent).resize(true);
            DisplayComponent.get(CharacterComponent).resize(true);
            this.background.addChild(character);
        }
        else {
            scale = 1.0 * Math.min(screenWidth / 1080, screenHeight / 1920);
            //bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale.set(scale, scale);

            const xPos = (MaxGameWidthHeight * scale - screenWidth) / 2;
            const yPos = ((MaxGameWidthHeight + 0) * scale - screenHeight) / 2;

            // this.y = -300 * scale;

            this.background.x = -xPos;
            this.background.y = -yPos;
            // this.addChild(this.game);
            // this.addChild(this.background);


            this.reelFrame.scale = 1;
            this.reelFrame.position.set(1024, 900);

            this.jackpotPanelContainer.scale.set(0.8)
            this.jackpotPanelContainer.position.set(1020, 650);
            DisplayComponent.get(CharacterComponent).resize(false);
            this.background.addChild(character);
            this.background.addChild(this.reelFrame);
            this.background.addChild(this.jackpotPanelContainer);


            // if (this.gameIntro) {
            //     this.addChild(this.gameIntro);
            //     this.gameIntro.scale.set(bgScale, bgScale)
            //     const bgXPos = screenWidth / 2;
            //     const bgYPos = screenHeight / 2;
            //     this.gameIntro.position.set(bgXPos, bgYPos);
            // }
            DisplayComponent.get(LogoComponent).resize(false);

        }

        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, screenHeight / 2);
        this.bigWin?.resize(screenWidth, screenHeight);

    }


}
